var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "up-down-icon",
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5378 28.7755L29.8438 29.3877L29.1498 28.7755L29.1498 10.4086L29.8438 9.79634L30.5378 10.4086L30.5378 28.7755Z",
    fill: "#00FF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76538 28.7755L2.07136 29.3877L1.37735 28.7755L1.37734 10.4086L2.07136 9.79634L2.76538 10.4086L2.76538 28.7755Z",
    fill: "#00FF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6082 33.6729L22.9141 34.2852L22.2201 33.6729L22.2201 5.51035L22.9141 4.89812L23.6081 5.51035L23.6082 33.6729Z",
    fill: "#00FF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71655 33.6729L9.02254 34.2852L8.32852 33.6729L8.32851 5.51035L9.02253 4.89812L9.71654 5.51035L9.71655 33.6729Z",
    fill: "#00FF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6462 38.5714L15.9522 39.1836L15.2582 38.5714L15.2582 0.61312L15.9522 0.000889946L16.6462 0.61312L16.6462 38.5714Z",
    fill: "#00FF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8699 1.74923L15.9519 3.15137e-06L18.034 1.74923L18.034 16.6177L15.9519 18.3669L13.8699 16.6177L13.8699 1.74923Z",
    fill: "#00FF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.821 6.64669L22.9031 4.89746L24.9851 6.64669L24.9852 14.1684L22.9031 15.9176L20.821 14.1684L20.821 6.64669Z",
    fill: "#00FF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7507 11.5451L29.8328 9.7959L31.9148 11.5451L31.9148 11.7201L29.8328 13.4693L27.7507 11.7201L27.7507 11.5451Z",
    fill: "#00FF00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92944 6.64669L9.0115 4.89746L11.0935 6.64669L11.0936 19.0662L9.0115 20.8154L6.92945 19.0662L6.92944 6.64669Z",
    fill: "#00FF00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31212e-07 11.5452L2.08205 9.79601L4.1641 11.5452L4.16411 21.5158L2.08206 23.2651L4.47181e-06 21.5158L6.31212e-07 11.5452Z",
    fill: "#00FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownIcon);
export default __webpack_public_path__ + "static/media/up-down-icon.8239814a351931b54409ee6efc41398c.svg";
export { ForwardRef as ReactComponent };